module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "backMatterPage",
    attrs: {
      "id": "atn01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle1"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#atn_01"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Author’s Note")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("T")])]), _vm._v("his is a work of nonfiction. I have rendered the events faithfully and truthfully just as I have recalled them. Some names and descriptions of individuals have been changed in order to respect their privacy. To anyone whose name I did not recall or omitted, I offer sincere apologies. While circumstances and conversations depicted herein come from my keen recollection of them, they are not meant to represent precise time lines of events or exact word-for-word reenactments of my life. They are told in a way that evokes the real feeling and meaning of what was said and my view of what happened to me, in keeping with the true essence of the mood and spirit of those moments that shaped my life.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b2a05f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/authorsnote.vue
// module id = 75
// module chunks = 0